import {
    addDays,
    formatDate,
    getEndOfWorkDay,
    getStartOfWorkDay,
} from '../../../../helpers/date'
import legacyParse from '../../../../helpers/legacyDateParser'

interface Props {
    justifiedStartDate: Date;
    justifiedEndDate: Date;
}

const dateFormat = 'yyyy-MM-dd'

/**
 * Returns true if endTime is before or equal to startTime (meaning it spills into the next day).
 */
const isOvernightShift = (startTime: string, endTime: string): boolean => {
    const [startHour, startMinute] = startTime.split(':').map(Number)
    const [endHour, endMinute] = endTime.split(':').map(Number)

    return endHour < startHour || (endHour === startHour && endMinute <= startMinute)
}

export const generateJustifiedStartAndEndDate = (
    date: string,
    startTime: string,
    endTime: string,
    startDate: string,
    endDate: string,
    multipleDays: boolean,
): Props => {
    if (multipleDays) {
        return {
            justifiedStartDate: getStartOfWorkDay(startDate),
            justifiedEndDate: getEndOfWorkDay(endDate),
        }
    }

    const parsedDate = legacyParse(date)
    const endDateObject = isOvernightShift(startTime, endTime)
        ? addDays(parsedDate, 1)
        : parsedDate

    return {
        justifiedStartDate: legacyParse(`${formatDate(parsedDate, dateFormat)} ${startTime}:00`),
        justifiedEndDate: legacyParse(`${formatDate(endDateObject, dateFormat)} ${endTime}:00`),
    }
}
